var _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 7.25,
    y1: 7.75,
    x2: 24.75,
    y2: 7.75,
    stroke: "#00842F",
    strokeWidth: 2.5,
    strokeLinecap: "square"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 7.25,
    y1: 15.75,
    x2: 24.75,
    y2: 15.75,
    stroke: "#00842F",
    strokeWidth: 2.5,
    strokeLinecap: "square"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 7.25,
    y1: 23.75,
    x2: 24.75,
    y2: 23.75,
    stroke: "#00842F",
    strokeWidth: 2.5,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.22c2a2cf.svg";
export { ForwardRef as ReactComponent };